import { HubAction } from './hub.action';

export class OrderEnteringEditModeAction extends HubAction {
    /**
     *
     */
    constructor(user: string, orderNumber: number) {
        super('EnteringEditMode', user, orderNumber);
    }

    public action(): void {
        // nothing todo
    }
}
